/* ----------------------------------------------------------------------------
 *                         General validity functions
 * ----------------------------------------------------------------------------*/

/**
 * 通用验证函数模板
 * @param {*} value - 待验证的值
 * @param {object} schema - 验证规则
 * @param {boolean} strict - 严格模式
 * @param {boolean} abortEarly - 提前终止验证
 * @throws
 * @returns {object} - 验证结果
 */
function validate(value, schema, strict = false, abortEarly = false) {
    return schema.validateSync(value, { strict, abortEarly });
}

export { validate };